import * as tslib_1 from "tslib";
import * as React from 'react';
import styled from 'styled-components';
import Button from '../Button';
import Typography from '../Typography';
import Popover from '../Popover';
var StyledButton = styled(Button)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  min-width: 66px;\n"], ["\n  padding: 0;\n  margin: 0;\n  min-width: 66px;\n"])));
var ActionsWrapper = styled.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n"])));
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (props) { return (props.inline ? 'inline-block' : 'block'); });
var Confirm = /** @class */ (function (_super) {
    tslib_1.__extends(Confirm, _super);
    function Confirm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (event) {
            event.stopPropagation();
            _this.setState({
                anchorEl: event.currentTarget,
            });
        };
        _this.handleClose = function () {
            _this.setState({
                anchorEl: null,
            });
        };
        _this.state = {
            anchorEl: null,
        };
        return _this;
    }
    Confirm.prototype.render = function () {
        var _this = this;
        var anchorEl = this.state.anchorEl;
        var _a = this.props, _b = _a.anchorOrigin, anchorOrigin = _b === void 0 ? { vertical: 'bottom', horizontal: 'left' } : _b, onOk = _a.onOk, other = tslib_1.__rest(_a, ["anchorOrigin", "onOk"]);
        var paperWidth = this.props.width ? this.props.width : 240;
        var paperHeight = this.props.height ? this.props.height : 120;
        return (React.createElement(Wrapper, { inline: this.props.inline },
            React.cloneElement(React.Children.only(this.props.children), {
                onClick: this.handleClick,
            }),
            React.createElement(Popover, tslib_1.__assign({}, other, { marginThreshold: 8, open: Boolean(anchorEl), anchorEl: anchorEl, anchorOrigin: anchorOrigin, PaperProps: {
                    style: {
                        padding: 16,
                        width: paperWidth,
                        height: paperHeight,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                    },
                }, onRequestClose: this.handleClose }),
                React.createElement(Typography, { type: "subheading" }, this.props.message),
                React.createElement(ActionsWrapper, null,
                    React.createElement(StyledButton, { style: { marginRight: 8 }, raised: true, color: "primary", onClick: function (e) {
                            _this.handleClose();
                            return _this.props.onOk(e);
                        } }, "\u786E\u5B9A"),
                    React.createElement(StyledButton, { border: true, onClick: this.handleClose }, "\u53D6\u6D88")))));
    };
    return Confirm;
}(React.Component));
export default Confirm;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Confirm.js.map